import * as styles from './index.css';
import { CheckCircle as CheckCircleIcon, XCircle as XCircleIcon } from '@phosphor-icons/react';
import Typography from '@blueshift-ui/theme/dist/components/typography';

interface EntitlementRowProps {
  hasFreePlan: boolean;
  hasPaidPlan: boolean;
  label: string;
}

function EntitlementRow({ hasFreePlan, hasPaidPlan, label }: EntitlementRowProps) {
  return (
    <div className={styles.row}>
      <div className={styles.labelCell}>
        <Typography className={styles.label} variant="body2">
          {label}
        </Typography>
      </div>
      <div className={styles.iconCell}>
        {hasPaidPlan ? (
          <CheckCircleIcon className={styles.includedIcon} size={40} weight="duotone" />
        ) : (
          <XCircleIcon className={styles.notIncludedIcon} size={40} weight="duotone" />
        )}
      </div>
      <div className={styles.iconCell}>
        {hasFreePlan ? (
          <CheckCircleIcon className={styles.includedIcon} size={40} weight="duotone" />
        ) : (
          <XCircleIcon className={styles.notIncludedIcon} size={40} weight="duotone" />
        )}
      </div>
    </div>
  );
}

export default EntitlementRow;
